import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import Loader from "../../../../DefaultStyles/Loader";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";

interface PopupNotiDeleteModalProps extends DefaultModalCommonProps {
  popupId: number;
}

export default function PopupNotiDeleteModal({
  closeEvent,
  confirmEvent,
  popupId,
}: PopupNotiDeleteModalProps) {
  const [reason, setReason] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);

  const { response, loading, error } = useApi({
    method: "delete",
    url: deletePopup ? `popup/${popupId}` : undefined,
    data: {
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      toast.success("팝업이 취소되었습니다.");
      closeEvent();
      if (confirmEvent) {
        confirmEvent();
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "팝업 리스트를 삭제하는 데에 실패하였습니다.");
      setDeletePopup(false);
    }
  }, [error]);

  return (
    <DefaultModalLayout
      isDeleteModal={true}
      isSmallModal={true}
      modalTitle="팝업 삭제"
      closeEvent={() => closeEvent()}
      confirmEvent={() => setDeletePopup(true)}
      confirmDisabled={reason === ""}
    >
      <>
        <ModalLabel>삭제 사유</ModalLabel>

        <Textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="삭제 사유 직접 입력 (100글자 이내)"
        />

        {loading && <Loader />}
      </>
    </DefaultModalLayout>
  );
}
